/**
 * Utility to remove duplicates from User Voice data split by comma
 */
export default function removeDuplicatesFromUserVoiceData(content: string[]): string {
    if (!content) {
        return '';
    }

    let newArray = content.filter(function(item: string, indexOfItem: number, self: string[]) {
        return indexOfItem == self.indexOf(item);
    });
    return newArray.join(',');
}
